import { initList } from "./section.list";
import { initImagesComparison } from "./section.images-comparison";
import { initHeader } from "./header";
import { initCards } from "./section.cards";
import { initApartmentCard } from "./section.apartment-card";
import { initConstructionProgress } from "./section.construction-progress";
import { initFAQ } from "./section.faq";
import { initTitle } from "./section.title";
import { initIframe } from "./section.iframe";
import { initTwoColumnsText } from "./section.two-columns-text";
import { initChooser } from "./section.chooser";
import { initInfrastructure } from "./section.infrastructure";
import { initTextsSlider } from "./section.slideshow-with-text";
import { initYieldPrograms } from "./section.yield-programs";
import { initChooserVisual } from "./section.chooser-visual";
import { initTimeLine } from "./section.timeline";
import { initHeroScreenSlider } from "./section.hero-screen-new";
import { initObjectsSlider } from "./section.objects";
import { initMediaWithTooltips } from "./section.media-with-tooltips";
import { initSlideshowAccordeon } from "./section.slideshow-accordeon";
import { initFullScreenSlider } from "./section.slideshow-fullscreen";
import { initSlideshow } from "./section.slideshow";
import { initInfrastructureTooltips } from "./section.infrastructure-tooltips";
import { initBrokersProjects } from "./section.brokers-projects";

export const initComponents = () => {
	initList();
	initImagesComparison();
	initHeader();
	initHeroScreenSlider();
	initObjectsSlider();
	initCards();
	initApartmentCard();
	initConstructionProgress();
	initFAQ();
	initTitle();
	initIframe();
	initTwoColumnsText();
	initChooser();
	initInfrastructure();
	initTextsSlider();
	initYieldPrograms();
	initChooserVisual();
	initTimeLine();
	initMediaWithTooltips();
	initSlideshowAccordeon();
	initFullScreenSlider();
	initSlideshow();
	initInfrastructureTooltips();
    initBrokersProjects();
};
